import { render, staticRenderFns } from "./QuestionInputNumber.vue?vue&type=template&id=a89cb752&"
import script from "./QuestionInputNumber.vue?vue&type=script&lang=ts&"
export * from "./QuestionInputNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports